export default __webpack_public_path__ + "static/media/ok-new.e1c52bdf.svg";